// libs
import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

// languages
import en from './translations/en'
import ar from './translations/ar'
import da from './translations/da'
import de from './translations/de'
import el from './translations/el'
import es from './translations/es'
import fi from './translations/fi'
import fr from './translations/fr'
import hi from './translations/hi'
import id from './translations/id'
import it from './translations/it'
import jp from './translations/jp'
import kr from './translations/kr'
import nl from './translations/nl'
import no from './translations/no'
import pt from './translations/pt'
import ru from './translations/ru'
import sv from './translations/sv'
import th from './translations/th'
import tr from './translations/tr'
import tw from './translations/tw'
import zh from './translations/zh'

export default i18n
.use(LanguageDetector)
.use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      da: { translation: da },
      de: { translation: de },
      el: { translation: el },
      es: { translation: es},
      fi: { translation: fi },
      fr: { translation: fr },
      hi: { translation: hi },
      id: { translation: id },
      it: { translation: it },
      jp: { translation: jp },
      kr: { translation: kr },
      nl: { translation: nl },
      no: { translation: no },
      pt: { translation: pt },
      ru: { translation: ru },
      sv: { translation: sv},
      th: { translation: th },
      tr: { translation: tr },
      tw: { translation: tw },
      zh: { translation: zh},
      ar_ar: { translation: ar },
      da_da: { translation: da },
      de_de: { translation: de },
      el_gr: { translation: el },
      en_us: { translation: en },
      es_es: { translation: es},
      fi_fi: { translation: fi },
      fr_fr: { translation: fr },
      hi_in: { translation: hi },
      id_id: { translation: id },
      it_it: { translation: it },
      jp_jp: { translation: jp },
      kr_kr: { translation: kr },
      nl_nl: { translation: nl },
      no_no: { translation: no },
      pt_pt: { translation: pt },
      pt_br: { translation: pt },
      ru_ru: { translation: ru },
      sv_sv: { translation: sv},
      th_th: { translation: th },
      tr_tr: { translation: tr },
      zh_tw: { translation: tw },
      zh_zh: { translation: zh},
    },
    fallbackLng: "en",
  })
